import Service from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';

export default class HelpTextService extends Service {
  bodycache: { [url: string]: string } = {};
  titlecache: { [url: string]: string } = {};
  async helpText(url: string): Promise<string> {
    if (Object.prototype.hasOwnProperty.call(this.bodycache, 'url')) {
      return this.bodycache[url] as string;
    }
    let result;
    try {
      const response = await waitForPromise(fetch(url));
      result = await response.text();
    } catch (error: unknown) {
      const namedError = error as { message: string };
      throw new Error(`Help Text for ${url} failed fetch: ` + namedError.message);
    }
    const titlestart = result.indexOf('<title>');
    const titleend = result.indexOf('</title>');
    if (titlestart !== -1 && titleend !== -1) {
      const title = result.substring(titlestart + 7, titleend);
      this.titlecache[url] = title;
    }

    const bodystart = result.indexOf('<body');
    const bodyend = result.indexOf('</body>');
    if (bodystart !== -1 && bodyend !== -1) {
      const bodyendstart = result.substring(bodystart).indexOf('>');
      const body = result.substring(bodystart + bodyendstart + 1, bodyend);
      this.bodycache[url] = body;
      return body;
    } else throw new Error(`Help Text for ${url} has no HTML body`);
  }

  async hasTitle(url: string): Promise<boolean> {
    await this.helpText(url);
    return Object.prototype.hasOwnProperty.call(this.titlecache, 'url');
  }

  async helpTitle(url: string): Promise<string> {
    await this.helpText(url);
    if (Object.prototype.hasOwnProperty.call(this.titlecache, 'url')) {
      return this.titlecache[url] as string;
    } else throw new Error(`Help Text for ${url} has no HTML title`);
  }

  toICUMessage(text: string): string {
    //TODO: Escape all < and > in text
    return text;
  }
}

declare module '@ember/service' {
  interface Registry {
    'help-text': HelpTextService;
  }
}
